import { ComponentProps, FC, useState } from 'react'
import { Button, Checkbox, ModalCenter } from 'src/components'
import { useBehaviorMapper } from 'src/hooks'
import { getCampaignShareLink } from 'src/modules/jobs/utils'
import { SnackbarService } from 'src/services'
import { AuthModule } from 'src/store'

interface IProps extends ComponentProps<typeof ModalCenter> {
  slug: string
}

export const ModalCopyJobLink: FC<IProps> = ({ slug, ...props }) => {
  const communities = useBehaviorMapper(AuthModule.communities$)
  const [selectedState, setSelectedState] = useState<string | null | undefined>()

  return (
    <ModalCenter {...props}>
      <div className="fx-column gap-8" style={{ maxWidth: 440 }}>
        <div className="fx-column gap-2">
          <div className="text-center semibold-24 txt-black-01">Link to a Community</div>
          <div className="text-center body-14 txt-black-02">
            Choose one of your communities to link to this job listing.<br/>
            When Talent apply through that link, they’ll automatically become members of the selected community.
          </div>
        </div>

        <div className="fx-column gap-3" style={{ maxHeight: 250, overflow: 'auto' }}>
          <div className="fx gap-3 px-4 py-3 round-3 bg-neutral-100">
            <Checkbox
              label="Don’t link this job listing to a community"
              checked={selectedState === null}
              onChange={() => setSelectedState(selectedState === null ? undefined : null)}
            />
          </div>
          {communities.map((community) => (
            <div key={community.id} className="fx gap-3 px-4 py-3 round-3 bg-neutral-100">
              <Checkbox
                label={community.description || community.name}
                checked={selectedState === community.code}
                onChange={() => setSelectedState(selectedState === community.code ? undefined : community.code)}
              />
            </div>
          ))}
        </div>

        <Button
          className="py-4 bold-14"
          onClick={() => {
            const link = selectedState
              ? getCampaignShareLink(slug) + '?community=' + selectedState
              : getCampaignShareLink(slug)
            navigator.clipboard.writeText(link).then(() => {
              SnackbarService.success('Link copied.')
            })
            props.onClose?.()
          }}
          disabled={selectedState === undefined}
        >
          Get Shareable Link
        </Button>
      </div>
    </ModalCenter>
  )
}
